// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PrincipalGrant } from './principal-grant';
import {
    PrincipalGrantFromJSON,
    PrincipalGrantFromJSONTyped,
    PrincipalGrantToJSON,
    PrincipalGrantToJSONTyped,
} from './principal-grant';

/**
 * 
 * @export
 * @interface PrincipalDetail
 */
export interface PrincipalDetail {
    /**
     * 
     * @type {string}
     * @memberof PrincipalDetail
     */
    company_id: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrincipalDetail
     */
    email: string;
    /**
     * 
     * @type {Array<PrincipalGrant>}
     * @memberof PrincipalDetail
     */
    grants: Array<PrincipalGrant>;
    /**
     * 
     * @type {string}
     * @memberof PrincipalDetail
     */
    principal_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof PrincipalDetail
     */
    signed_in: boolean;
    /**
     * 
     * @type {string}
     * @memberof PrincipalDetail
     */
    status: PrincipalDetailStatusEnum;
}


/**
 * @export
 */
export const PrincipalDetailStatusEnum = {
    Active: 'active',
    Pending: 'pending'
} as const;
export type PrincipalDetailStatusEnum = typeof PrincipalDetailStatusEnum[keyof typeof PrincipalDetailStatusEnum];


/**
 * Check if a given object implements the PrincipalDetail interface.
 */
export function instanceOfPrincipalDetail(value: object): value is PrincipalDetail {
    if (!('company_id' in value) || value['company_id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('grants' in value) || value['grants'] === undefined) return false;
    if (!('principal_id' in value) || value['principal_id'] === undefined) return false;
    if (!('signed_in' in value) || value['signed_in'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function PrincipalDetailFromJSON(json: any): PrincipalDetail {
    return PrincipalDetailFromJSONTyped(json, false);
}

export function PrincipalDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrincipalDetail {
    if (json == null) {
        return json;
    }
    return {
        
        'company_id': json['company_id'],
        'email': json['email'],
        'grants': ((json['grants'] as Array<any>).map(PrincipalGrantFromJSON)),
        'principal_id': json['principal_id'],
        'signed_in': json['signed_in'],
        'status': json['status'],
    };
}

export function PrincipalDetailToJSON(json: any): PrincipalDetail {
    return PrincipalDetailToJSONTyped(json, false);
}

export function PrincipalDetailToJSONTyped(value?: PrincipalDetail | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'company_id': value['company_id'],
        'email': value['email'],
        'grants': ((value['grants'] as Array<any>).map(PrincipalGrantToJSON)),
        'principal_id': value['principal_id'],
        'signed_in': value['signed_in'],
        'status': value['status'],
    };
}
